import { Injectable, ViewChild } from '@angular/core';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { debounceTime, map } from 'rxjs/operators';
import { AlertDialogService } from '../../Services/Alert/alert.service'
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
//import { emit } from 'cluster';
declare var $: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Injectable({
    providedIn: 'root'
})
export class CommonGridService {
    constructor(private http: HttpClient, private alert: AlertDialogService) { }
    keyCodes = [9, 13, 16, 17, 18, 35, 36, 37, 38, 39, 40, 52, 91, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 192];
    // let tooBarObj = {
    //     currenComponentObj : this,
    //     gridObj : this.orgRegistrationGrid,
    //     toolbarObj : toolbar,
    //     buttonObj : buttonIdObj,
    //     addRowMethodObj : this.addOrgNewRow,
    //     deleteRowMethodObj : '',
    //     downloadGridMethodObj : this.downloadOuRegistration,
    //   };
    // generateToolBar(grid: jqxGridComponent, tool: any, buttonId: any, addMethod: Function, downloadMethod: Function, currentObject: any, minmumRow: Number) {
    generateToolBar(toolBar) {
        console.log(toolBar);
        let gridTitle: any = toolBar.gridTitle;
        let componentObj: any = toolBar.currenComponentObj;
        let grid: jqxGridComponent = toolBar.gridObj;
        let tool: any = toolBar.toolbarObj;
        let buttonId: any = toolBar.buttonObj;
        let addMethod: Function = toolBar.addRowMethodObj;
        let upMethod: Function = toolBar.upRowMethodObj;
        let downMethod: Function = toolBar.downRowMethodObj;
        let downloadMethod: Function = toolBar.downloadGridMethodObj;
        let deleteRowMethod: Function = toolBar.deleteRowMethodObj;
        let additionalToolBar: Array<Function> = toolBar.additionalToolBar;
        let upButtonID = "upButton";
        let downButtonID = "downButton";
        let addButtonID = "addButton";
        let deleteButtonID = "deleteButton";
        let downloadButtonID = "downloadButton";
        let container = document.createElement('div');
        container.style.margin = '5px';
        container.style.cssFloat = 'right';
        container.style.paddingRight = '25px';
        tool[0].appendChild(container);
        // addButtonContainer.style.cssText = 'float: left; border:0; width: 0px !important; cursor: pointer;'
        // deleteButtonContainer.style.cssText = 'float: left; margin-left: 5px; border:0;width: 0px !important; cursor: pointer;'
        if (gridTitle) {
            console.log(gridTitle)
            let titleContainer = document.createElement('div');
            titleContainer.innerText = gridTitle;
            titleContainer.className = "gridTitle";
            // titleContainer.style.cssFloat = 'left';
            // container.style.paddingLeft = '25px';
            tool[0].appendChild(titleContainer);
        }
        if (buttonId && buttonId.add != undefined) {
            addButtonID = buttonId && buttonId.add ? buttonId.add : addButtonID;
            let addButtonContainer = document.createElement('div');
            addButtonContainer.className = 'fa fa-plus-circle gridAddButton'
            addButtonContainer.id = addButtonID;
            container.appendChild(addButtonContainer);
            let addRowButton = jqwidgets.createInstance('#' + addButtonID, 'jqxButton', {/* width: 105*/ });
            addRowButton.addEventHandler('click', () => {
                if (!grid.disabled()) {
                    // grid.endcelledit(grid.getselectedrowindex(), "commodity", true);
                    // grid.endrowedit(0, false); 
                    //   console.log( (grid.source() as any)._source.datafields)
                    //   console.log( grid.getselectedrowindex());
                    // (grid.source() as any)._source.datafields.forEach(element => {
                    //     grid.endcelledit(grid.getselectedrowindex(), element.name, false);
                    // });
                    // grid.onCellendedit;
                    // grid.onCellendedit.subscribe((res) => {
                    //     console.log(res);
                    // });
                    grid.selectrow(grid.getselectedrowindex());
                   
                    // grid.updatebounddata();
                    // grid.beginupdate();
                    // grid.refreshaggregates();
                    // $(".gateInContainerGrid").jqxGrid('endcelledit', 0, "tareWeight", false);
                    let datarow = addMethod(componentObj);
                    //console.log(datarow);
                    // if (datarow)
                    // {
                    grid.addrow(null, datarow);
                    // }
                }
            });
        }
        if (buttonId && buttonId.up != undefined) {
            upButtonID = buttonId && buttonId.up ? buttonId.up : upButtonID;
            let upButtonContainer = document.createElement('div');
            upButtonContainer.className = 'fa fa-arrow-up gridAddButton'
            upButtonContainer.id = upButtonID;
            container.appendChild(upButtonContainer);
            let upRowButton = jqwidgets.createInstance('#' + upButtonID, 'jqxButton', {/* width: 105*/ });
            upRowButton.addEventHandler('click', () => {
                if (!grid.disabled()) {
                    // grid.endcelledit(grid.getselectedrowindex(), "commodity", true);
                    // grid.endrowedit(0, false); 
                    //   console.log( (grid.source() as any)._source.datafields)
                    //   console.log( grid.getselectedrowindex());
                    // (grid.source() as any)._source.datafields.forEach(element => {
                    //     grid.endcelledit(grid.getselectedrowindex(), element.name, false);
                    // });
                    // grid.onCellendedit;
                    // grid.onCellendedit.subscribe((res) => {
                    //     console.log(res);
                    // });
                    grid.selectrow(grid.getselectedrowindex());
                    // console.log('Grid Rows==========================');
                    // console.log(grid.getrows());
                    // let cRowss = grid.getrows();
                    // let rr = 0;
                    // let selectedrowidx = grid.getselectedrowindex();
                    // if(cRowss.length>0){
                    //     cRowss.forEach(element => {
                    //         if(selectedrowidx-1 == rr){
                    //             element.Inc = selectedrowidx;
                    //         }if(selectedrowidx == rr){
                    //             element.Inc = selectedrowidx-1;
                    //         }else{
                    //             element.Inc = rr;
                    //         }
                    //         grid.updaterow(rr, element);
                    //         rr++;
                           
                    //     });
                    // }
                   
                   // grid.updatebounddata();
                    // grid.updatebounddata();
                    // grid.beginupdate();
                    // grid.refreshaggregates();
                    // $(".gateInContainerGrid").jqxGrid('endcelledit', 0, "tareWeight", false);
                    let datarow = upMethod(componentObj);
                   // console.log(datarow);
                    // if (datarow)
                    // {
                   // grid.uprow(null, datarow);
                    // }
                }
            });
        }
        if (buttonId && buttonId.down != undefined) {
            downButtonID = buttonId && buttonId.down ? buttonId.down : downButtonID;
            let downButtonContainer = document.createElement('div');
            downButtonContainer.className = 'fa fa-arrow-down gridAddButton'
            downButtonContainer.id = downButtonID;
            container.appendChild(downButtonContainer);
            let downRowButton = jqwidgets.createInstance('#' + downButtonID, 'jqxButton', {/* width: 105*/ });
            downRowButton.addEventHandler('click', () => {
                if (!grid.disabled()) {
                    grid.selectrow(grid.getselectedrowindex());
                    let datarow = downMethod(componentObj);
                }
            });
        }
        if (buttonId && buttonId.delete != undefined) {
            deleteButtonID = buttonId && buttonId.delete ? buttonId.delete : deleteButtonID;
            let deleteButtonContainer = document.createElement('div');
            deleteButtonContainer.id = deleteButtonID;
            deleteButtonContainer.className = 'fa fa-minus-circle gridDeleteButton'
            container.appendChild(deleteButtonContainer);
            let deleteRowButton = jqwidgets.createInstance('#' + deleteButtonID, 'jqxButton', { /* width: 105*/ });
            deleteRowButton.addEventHandler('click', () => {
                if (!grid.disabled()) {
                    if (toolBar.deleteRowMethodObj) {
                        let gridColumnAttributes = grid.attrColumns;
                        gridColumnAttributes.forEach((attribute, i) => {
                            if (attribute.datafield) {
                                grid.endcelledit(i, attribute.datafield, true);
                            }
                        })
                        toolBar.deleteRowMethodObj(componentObj);
                    } else {
                        let gridColumnAttributes = grid.attrColumns;
                        gridColumnAttributes.forEach((attribute, i) => {
                            if (attribute.datafield) {
                                grid.endcelledit(i, attribute.datafield, true);
                            }
                        })
                        let selectedrowindexes = grid.getselectedrowindexes();
                        let rowscount = grid.getdatainformation().rowscount;
                        if (selectedrowindexes.length > 0) {
                            if (Number(rowscount) > 1) {
                                let deleteRows: any = [];
                                selectedrowindexes.forEach(index => {
                                    if (index >= 0 && index < parseFloat(rowscount)) {
                                        let rowId = grid.getrowid(index);
                                        deleteRows.push(rowId);
                                    }
                                });
                                if (deleteRows.length > 0) {
                                    grid.deleterow(deleteRows);
                                    // let rowscountAfterDelete = grid.getdatainformation().rowscount;
                                    // if (Number(rowscountAfterDelete) == 0) {
                                    //     grid.clear();
                                    //     let datarow = addMethod(componentObj);
                                    //     grid.addrow(null, datarow);
                                    // }
                                }
                            } else {
                                // grid.clear();
                                // let datarow = addMethod(componentObj);
                                // grid.addrow(null, datarow);
                            }
                        } else {
                            this.alert.openSnackBar("No row selected", '');
                        }
                    }
                }
            });
        }
        if (buttonId && buttonId.download != undefined) {
            downloadButtonID = buttonId && buttonId.download ? buttonId.download : downloadButtonID;
            let downloadButtonContainer = document.createElement('div');
            downloadButtonContainer.id = downloadButtonID;
            downloadButtonContainer.className = 'fa fa-arrow-circle-down gridDownloadButton'
            container.appendChild(downloadButtonContainer);
            let downloadRowButton = jqwidgets.createInstance('#' + downloadButtonID, 'jqxButton', { /* width: 105*/ });
            downloadRowButton.addEventHandler('click', () => {
                if (gridTitle == "Include Exclude Permission") {
                    downloadMethod(componentObj)
                } else {
                    this.downloadGrid(grid, gridTitle);
                }
            });
        }
        if (additionalToolBar) {
            additionalToolBar.forEach(toolInit => {
                toolInit(container);
            });
        }
        var scope = this;
        // addMultipleRowsButton.addEventHandler('click', () => {
        //     this.orgAddressGrid.beginupdate();
        //     for (let i = 0; i < 10; i++) {
        //         let datarow = this.generaterow();
        //         this.orgAddressGrid.addrow(null, datarow);
        //     }
        //     this.orgAddressGrid.endupdate();
        // })
        // updateRowButton.addEventHandler('click', () => {
        //     let datarow = this.generaterow();
        //     let selectedrowindex = this.orgAddressGrid.getselectedrowindex();
        //     let rowscount = this.orgAddressGrid.getdatainformation().rowscount;
        //     if (selectedrowindex >= 0 && selectedrowindex < parseFloat(rowscount)) {
        //         let id = this.orgAddressGrid.getrowid(selectedrowindex);
        //         this.orgAddressGrid.updaterow(id, datarow);
        //         this.orgAddressGrid.ensurerowvisible(selectedrowindex);
        //     }
        // })
    }
    // gridAutoCompleteCreateEditor(row: number, cellvalue: any, editor: any, cellText: any, width: any, height: any, url: string, dataField: string, getDependentFieldsParm?: Function, afterSelected?: Function) {
    //     // construct the editor.
    //     let input: any;
    //     let container = document.createElement('input');
    //     container.className = dataField + row + " gridInpuTextField";
    //     editor[0].appendChild(container);
    //     let options = {
    //         width: '200',
    //         height: '100%',
    //         // source: this.getAddressGridCombos('stateInput'),
    //         displayMember: 'Label',
    //         valueMember: 'Value',
    //     };
    //     input = jqwidgets.createInstance('.' + dataField + row, 'jqxInput', options);
    //     console.log(input);
    //     // jqx-input-widget
    //     let scope = this;
    //     $('.' + dataField + row).on('keyup',
    //     function (event) {
    //         if (!scope.keyCodes.includes(event.which) && event.currentTarget.value) {
    //             input.selectedItem = { label: '', value: '' }
    //             scope.getAutoCompleteSource(event.currentTarget.value, url, dataField, getDependentFieldsParm).then((response: any) => {
    //                 // ////console.log(response);
    //                 var res = response;
    //                 if (res[0].value == '') {
    //                     input.value = response.value;
    //                 } else {
    //                     input.source = response;
    //                 }
    //             });
    //         }
    //     });
    //     // input.input.addEventListener('keyup', (event: any): void =>
    //     // {
    //     // let inputValue =  $("#" + event.srcElement.id).val();
    //     //     }
    //     //     this.getAutoCompleteSource(inputValue, url, dataField, getDependentFieldsParm).then((response: any) =>
    //     //     {
    //     //         console.log(response);
    //     //         input.source = response;
    //     //     });
    //     // });
    //     editor.on('select', function (event) {
    //         if (event.args && event.args.type != 'api') {
    //             var object = input.source.find(function (obj) { return obj.Value == input.selectedItem.value })
    //             if (afterSelected) {
    //                 afterSelected(object);
    //             }
    //         }
    //     });
    //     $('.' + dataField + row).focus();
    //     return input;
    // }
    // gridAutoCompleteInitEditor(row: number, cellvalue: any, editor: any, celltext: any, pressedkey: any, input: any) {
    //     // set the editor's current value. The callback is called each time the editor is displayed. 
    //     if (pressedkey) {
    //         input.val(pressedkey);
    //         // input.selectLast();
    //     }
    //     else if (cellvalue) {
    //         input.val(cellvalue);
    //         input.selectAll();
    //     }
    //     else {
    //         input.val('');
    //         input.selectAll();
    //         // input.selectLast();
    //         // input.focus();
    //     }
    // }
    // gridAutoCompleteGeteditorvalue(row: number, cellvalue: any, editor: any, grid: jqxGridComponent, hiddenId: string, input) {
    //     // return the editor's value
    //     if (!input.val()) {
    //         grid.setcellvalue(row, hiddenId, undefined);
    //     } else if (input.val().value) {
    //         grid.setcellvalue(row, hiddenId, input.val().value);
    //     }
    //     return input.val().label || input.val();
    // }
    gridAutoCompleteCreateEditor(row: number, cellvalue: any, editor: any, cellText: any, width: any, height: any, url: string, dataField: string, getDependentFieldsParm?: Function, afterSelected?: Function) {
        // construct the editor.
        let input: any;
        let container = document.createElement('input');
        container.className = dataField + row + " gridInpuTextField";
        editor[0].appendChild(container);
        let options = {
            width: '100%',
            height: '100%',
            // source: this.getAddressGridCombos('stateInput'),
            displayMember: 'Label',
            valueMember: 'Value',
        };
        input = jqwidgets.createInstance('.' + dataField + row, 'jqxInput', options);
        console.log(input);
        // jqx-input-widget
        let scope = this;
        $('.' + dataField + row).on('keyup',
        function (event) {
            if (!scope.keyCodes.includes(event.which) && event.currentTarget.value) {
                input.selectedItem = { label: '', value: '' }
                scope.getAutoCompleteSource(event.currentTarget.value, url, dataField, getDependentFieldsParm).then((response: any) => {
                    console.log('Auto Res: ' + response);
                    var res = response;
                    if (res[0].value == '') {
                        input.value = response.value;
                    } else {
                        input.source = response;
                    }
                });
            }
        });
        // input.input.addEventListener('keyup', (event: any): void =>
        // {
        // let inputValue =  $("#" + event.srcElement.id).val();
        //     }
        //     this.getAutoCompleteSource(inputValue, url, dataField, getDependentFieldsParm).then((response: any) =>
        //     {
        //         console.log(response);
        //         input.source = response;
        //     });
        // });
        editor.on('select', function (event) {
            if (event.args && event.args.type != 'api') {
                var object = input.source.find(function (obj) { return obj.Value == input.selectedItem.value })
                if (afterSelected) {
                    afterSelected(object);
                }
            }
        });
        $('.' + dataField + row).focus();
        return input;
    }
    gridAutoCompleteInitEditor(row: number, cellvalue: any, editor: any, celltext: any, pressedkey: any, input: any) {
        // set the editor's current value. The callback is called each time the editor is displayed. 
        if (pressedkey) {
            input.val(pressedkey);
            // input.selectLast();
        }
        else if (cellvalue) {
            input.val(cellvalue);
            input.selectAll();
        }
        else {
            input.val('');
            input.selectAll();
            // input.selectLast();
            // input.focus();
        }
    }
    gridAutoCompleteGeteditorvalue(row: number, cellvalue: any, editor: any, grid: jqxGridComponent, hiddenId: string, input) {
        // return the editor's value
        if (!input.val()) {
            grid.setcellvalue(row, hiddenId, undefined);
        } else if (input.val().value) {
            grid.setcellvalue(row, hiddenId, input.val().value);
        }
        return input.val().label || input.val();
    }
    getAutoCompleteSource(searchText, uri, dataField, getDependentFieldsParm) {
        if(searchText){
        let states;
        return new Promise<string>((resolve, reject) => {
            this.search(searchText, uri, dataField, getDependentFieldsParm).subscribe(
                value => {
                    states = value as any[];
                    value.map(function (obj) {
                     //   obj.Label = obj.Label.replace('%','T');
                        obj.Label = '' + obj.Label;
                    })
                    resolve(states);
                });
        });
    }
    }
    search(value, url, fieldName, getDependentFieldsParm) {
        var params: any = {};
        if (getDependentFieldsParm && typeof getDependentFieldsParm === 'function') {
            params = getDependentFieldsParm(value);
        }
        if ($.isEmptyObject(params)) {
            params.searchText = value;
        }
        console.log(params);
        var listOfState = this.http.get(url, { params: params })
            .pipe(
                debounceTime(500),  // WAIT FOR 500 MILISECONDS ATER EACH KEY STROKE.
                map(
                    (value: any) => {
                        if(!value.result.Table){
                            return (
                                value.result.length != 0 ? value.result as any[] : [{ Label: "", value: "" } as any]
                            );
                        }else{
                            return (
                                value.result.Table.length != 0 ? value.result.Table as any[] : [{ Label: "", value: "" } as any]
                            );
                        }
                        
                    }
                ));
        return listOfState;
    }
    gridSelectionCheckBox(element, gridClassName) {
        console.log("checkbox");
        var columnCheckBox = null;
        var updatingCheckState = false;
        $(element).jqxCheckBox({ width: 16, height: 16, animationShowDelay: 0, animationHideDelay: 0 });
        columnCheckBox = $(element);
        // columnCheckBox.addEventListener('change', (event: any): void => {
        //    alert();
        // });
        $(element).on('change', function (event) {
            var checked = event.args.checked;
            var pageinfo = $(gridClassName).jqxGrid('getpaginginformation');
            var pagenum = pageinfo.pagenum;
            var pagesize = pageinfo.pagesize;
            if (checked == null || updatingCheckState) return;
            $(gridClassName).jqxGrid('beginupdate');
            // select all rows when the column's checkbox is checked.
            if (checked) {
                $(gridClassName).jqxGrid('selectallrows');
            }
            // unselect all rows when the column's checkbox is checked.
            else if (checked == false) {
                $(gridClassName).jqxGrid('clearselection');
            }
            // update cells values.
            var startrow = pagenum * pagesize;
            for (var i = startrow; i < startrow + pagesize; i++) {
                // The bound index represents the row's unique index. 
                // Ex: If you have rows A, B and C with bound indexes 0, 1 and 2, afer sorting, the Grid will display C, B, A i.e the C's bound index will be 2, but its visible index will be 0.
                // The code below gets the bound index of the displayed row and updates the value of the row's available column.
                var boundindex = $(gridClassName).jqxGrid('getrowboundindex', i);
                $(gridClassName).jqxGrid('setcellvalue', boundindex, 'available', event.args.checked);
            }
            $(gridClassName).jqxGrid('endupdate');
        });
        return true;
    }
    getGridEditedRows(gridClassName) {
        let rowscount = $(gridClassName).jqxGrid('getrows').length;
        let rows: any = [];
        for (var i = 0; i < Number(rowscount); i++) {
            let editRow = $(gridClassName).jqxGrid('getcelltext', i, 'rowEdit');
            if (Number(editRow) > 0) {
                let rowData = $(gridClassName).jqxGrid('getrowdata', i);
                rows.push(rowData);
            }
        }
        return rows
    }
    // checkGridMondatory(gridClassName, dataField: any, grid: jqxGridComponent) {
    //     console.log(dataField);
    //     let columnLength = dataField.length;
    //     let flag = true;
    //     var totalRows = $(gridClassName).jqxGrid('getrows').length;
    //     for (var x = 0; x < Number(totalRows); x++) {
    //         for (var i = 0; i < Number(columnLength); i++) {
    //             grid.getcelltext(1,'firstname');
    //             var columnData = $(gridClassName).jqxGrid('getcelltext', x, dataField[i])
    //             var isEdited = $(gridClassName).jqxGrid('getcelltext', x, "rowEdit");
    //             if (Number(isEdited) > 0 && (columnData == undefined || columnData == "")) {
    //                 var column = $(gridClassName).jqxGrid('getcolumn', dataField[i]);
    //                 var columnName = column.text.substr(0, column.text.indexOf('<'));
    //                 this.alert.openSnackBar(columnName + " is required row No : " + (x + 1), '');
    //                 flag = false;
    //                 return flag;
    //             } else {
    //                 flag = true;
    //             }
    //         }
    //     }
    //     return flag;
    // }
    exportAsExcelFile(json: any[], excelFileName: string) {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        console.log('worksheet', worksheet);
        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }
    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }
    checkGridMondatory(gridClassName, dataField: any) {
        console.log(dataField);
        let columnLength = dataField.length;
        let flag = true;
        var totalRows = $(gridClassName).jqxGrid('getrows').length;
        for (var x = 0; x < totalRows; x++) {
            for (var i = 0; i < Number(columnLength); i++) {
                var data = $(gridClassName).jqxGrid('getrowdata', x);
                var columnData = data[dataField[i]];
                if (columnData == undefined || columnData == "") {
                    var columnIndex = $(gridClassName).jqxGrid('getcolumnindex', 'name');
                    var column = $(gridClassName).jqxGrid('getcolumn', dataField[i]);
                    if (column.text.indexOf('<')) {
                        var columnName = column.text.substr(0, column.text.indexOf('<'));
                    } else {
                        var columnName = column.text;
                    }
                    // $(gridClassName).jqxGrid('showvalidationpopup', x, dataField[i], "Required");
                    this.alert.openSnackBar(columnName + " is required in " + (x + 1) + " row", '');
                    flag = false;
                    return flag;
                } else {
                    // $(gridClassName).jqxGrid('hidevalidationpopups');
                    flag = true;
                }
            }
        }
        return flag;
    }
    checkGridMondatoryWithoutRow(gridClassName, dataField: any, message: string) {
        let columnLength = dataField.length;
        let flag = true;
        var totalRows = $(gridClassName).jqxGrid('getrows').length;
        if (totalRows == 0) {
            this.alert.openSnackBar(message, '');
            flag = false;
            return flag;
        }
        for (var x = 0; x < totalRows; x++) {
            for (var i = 0; i < Number(columnLength); i++) {
                var data = $(gridClassName).jqxGrid('getrowdata', x);
                var columnData = data[dataField[i]];
                if (columnData == undefined || columnData == "") {
                    var columnIndex = $(gridClassName).jqxGrid('getcolumnindex', 'name');
                    var column = $(gridClassName).jqxGrid('getcolumn', dataField[i]);
                    if (column.text.indexOf('<')) {
                        var columnName = column.text.substr(0, column.text.indexOf('<'));
                    } else {
                        var columnName = column.text;
                    }
                    // $(gridClassName).jqxGrid('showvalidationpopup', x, dataField[i], "Required");
                    this.alert.openSnackBar(columnName + " is required in " + (x + 1) + " row", '');
                    flag = false;
                    return flag;
                } else {
                    // $(gridClassName).jqxGrid('hidevalidationpopups');
                    flag = true;
                }
            }
        }
        return flag;
    }
    getEditedRow(row, dataField, editedRowGridName) {
        var obj = editedRowGridName.get(row);
        if (obj) {
            obj[dataField] = true;
        } else {
            var newobj = {};
            newobj[dataField] = true;
            editedRowGridName.set(row, newobj);
        }
    }
    setCellColorForMandatoryIfEmpty(row, dataField, value, editedRowGridName) {
        let manDatoryFlag = false;
        if (!value) {
            var rowObj = editedRowGridName.get(row) as any;
            if (rowObj && rowObj[dataField]) {
                manDatoryFlag = true;
            }
        }
        return '<div class="jqx-grid-cell-left-align ' + (!manDatoryFlag ? "grid-row" : "grid-mandatory-row") + '">' + (value) + '</div>';
    }
    downloadGrid(grid: jqxGridComponent, gridTitle) {
        var cols: any = grid.columns();
        let rowscount = grid.getrows().length;
        let gridData: any = [];
        for (let i = 0; i < rowscount; i++) {
            let dataObj = {}
            for (var j = 0; j < cols.records.length; j++) {
                if (!cols.records[j].hidden) {
                    var columnName = cols.records[j].text.indexOf('<') != -1 ? cols.records[j].text.substr(0, cols.records[j].text.indexOf('<')) : cols.records[j].text;
                    dataObj[columnName] = columnName == "S.No" ? i + 1 : grid.getcelltext(i, cols.records[j].displayfield);
                }
            }
            gridData.push(dataObj);
        }
        console.log(gridData);
       this.exportAsExcelFile(gridData, gridTitle ? gridTitle : 'Data');
    }
}






